<template>
  <div class="flex">
    <inbound-header
      :variant="variant(INBOUND)"
      :can-select="userIsInboundStudentManager"
      @inbound-selected="() => setExchangeMode(INBOUND, 'acceptances')"
    /><outbound-header
      :variant="variant(OUTBOUND)"
      :can-select="userIsOutboundStudentManager"
      @outbound-selected="() => setExchangeMode(OUTBOUND, 'approvals')"
    />
  </div>
</template>
<script setup>
import { computed } from "vue";

import { InboundHeader, OutboundHeader } from "@/components/shared/icons";
import { useExchangeMode } from "../../composables/useExchangeMode";

const INBOUND = "inbound";
const OUTBOUND = "outbound";

const {
  exchangeMode,
  setExchangeMode,
  userIsInboundStudentManager,
  userIsOutboundStudentManager,
} = useExchangeMode();

const variant = computed(() => (selectedMode) => {
  return exchangeMode.value === selectedMode ? "active" : "inactive";
});
</script>
